/*
 * Copyright (c) 2020. Dave van Rijn Development
 */
import {generateUUID, getCookie, getMode, getSetting, setCookie, setDefaultHeaders} from '@dvrd/dvr-controls';
import {CookieAttributes} from 'js-cookie';

export const PASSWORD_RULES = {
    MIN_LENGTH: 8, MAX_LENGTH: 24, CONTAIN_NUMBER: true, CONTAIN_SYMBOL: true, CONTAIN_CAPITAL: true,
};

interface Validation {
    MIN_LENGTH: boolean,
    MAX_LENGTH: boolean,
    CONTAIN_NUMBER: boolean,
    CONTAIN_CAPITAL: boolean,
    CONTAIN_SYMBOL: boolean,
}

export const validatePassword = (password: string): Validation => {
    const {MIN_LENGTH, MAX_LENGTH, CONTAIN_CAPITAL, CONTAIN_NUMBER, CONTAIN_SYMBOL} = PASSWORD_RULES;
    return {
        MIN_LENGTH: password.length >= MIN_LENGTH,
        MAX_LENGTH: password.length <= MAX_LENGTH,
        CONTAIN_NUMBER: !CONTAIN_NUMBER || /\d/.test(password),
        CONTAIN_CAPITAL: !CONTAIN_CAPITAL || /[A-Z]/.test(password),
        CONTAIN_SYMBOL: !CONTAIN_SYMBOL || /[!.\/?@#$%^\\&*(),<>`~\-_=+]/.test(password)
    };
};

export const setDeviceId = () => {
    let deviceId = getCookie('dvr-apps-device-id');
    if (!deviceId) {
        deviceId = generateUUID();
        let options: CookieAttributes = {expires: 365};
        if (getSetting('mode') !== 'dev') {
            options.secure = true;
            options.sameSite = 'strict';
        }
        setCookie('dvr-apps-device-id', deviceId, options);
    }
    if (getMode() === 'dev')
        setDefaultHeaders({'X-Device-Id': deviceId});
};